import { render } from "./StockVideos.vue?vue&type=template&id=cd207a08&scoped=true"
import script from "./StockVideos.vue?vue&type=script&lang=js"
export * from "./StockVideos.vue?vue&type=script&lang=js"

import "./StockVideos.vue?vue&type=style&index=0&id=cd207a08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd207a08"]])

export default __exports__